import Phaser from "phaser";
import {LevelManager} from "../../game/LevelManager";

export const PowerupName = {
  BugsBunny: 'BugsBunny',
  MarvinMartian: 'MarvinMartian',
  PorkyPig: 'PorkyPig',
  RoadRunner: 'RoadRunner',
  TweetyBird: 'TweetyBird',
  YosemiteSam: 'YosemiteSam'
} as const;
export type PowerupNameKeys = keyof typeof PowerupName;
export type PowerupNameValues = typeof PowerupName[PowerupNameKeys];

export default class Powerup extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number,) {
    super(scene,x,y);
    this.playerX = x;
    this.playerY = y;
  }

  public duration:number = 1000;
  private time:number = 0;
  public levelManager!:LevelManager;
  public playerX:number = 0;
  public playerY:number = 0;
  protected hasDestroyed:boolean = false;
  protected affectsPlayerSpeed:boolean = false;
  protected affectsScore:boolean = false;
  public ApplyPowerup(levelManager:LevelManager)
  {
    this.time = this.duration;
    this.levelManager = levelManager;
  }

  public EndPowerup()
  {
    this.destroy(true);
    this.hasDestroyed = true;
  }

  public HasBeenDestroyed():boolean
  {
    return this.hasDestroyed;
  }

  public AffectsPlayerSpeed():boolean
  {
    return this.affectsPlayerSpeed;
  }

  public AffectsScore():boolean
  {
    return this.affectsScore;
  }

  public update(playerX:number, playerY:number, time:number, deltaTime:number)
  {
    this.time -= deltaTime;
    if(this.time <= 0)
    {
      this.EndPowerup();
    }

    this.playerX = playerX;
    this.playerY = playerY;
  }

  public modifyPlayerSpeed(vx:number, vy:number):{vx:number,vy:number}
  {
    return {vx:vx, vy:vy};
  }

  public modifyScore(score:number):number
  {
    return score;
  }

  public get multiplier()
  {
    return 1;
  }
}
